import Marquee from "react-fast-marquee";

// Marquee editorial lento con texto sólido + contorno
export const TextMarquee = ({
  items = [],
  speed = 34,
  className = "",
  bg = "bg-ink",
}) => {
  return (
    <div className={`${bg} py-6 sm:py-8 ${className}`}>
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`px-6 sm:px-10 font-display text-4xl sm:text-6xl font-extrabold uppercase tracking-tighter ${
                i % 2 === 0 ? "text-cream" : "text-transparent"
              }`}
              style={
                i % 2 === 0
                  ? {}
                  : { WebkitTextStroke: "1.5px #F7F9F6", color: "transparent" }
              }
            >
              {t}
            </span>
            <span className="text-coral text-2xl sm:text-4xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
